<template>
  <span>
    {{ date }}
  </span>
</template>

<script>
// Utils
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')

export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    date () {
      if (this.value) {
        return moment(this.value).format('DD-MM-YYYY HH:mm')
      }
      return null
    }
  }
}
</script>
